import {
  GET_SHORT_LINK,
  GET_SHORT_LINK_SUCCESS,
  GET_SHORT_LINK_FAIL,

  GET_SHORT_LINKS,
  GET_SHORT_LINKS_SUCCESS,
  GET_SHORT_LINKS_FAIL,
} from "../actions/shortLink";
import { TShortLinkReducer, TShortLinksAction } from 'cityads-v3/types/shortLink'

const initialState: TShortLinkReducer = {
  isLoading: {},
  isLoaded: {},
  isLoadedArr: [],
  shortLinks: {},
};

export default function shortLink(state: TShortLinkReducer = initialState, action: TShortLinksAction): TShortLinkReducer {
  switch (action.type) {
    case GET_SHORT_LINK:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.additional.id]: true,
        },
        isLoaded: {
          ...state.isLoaded,
          [action.additional.id]: false,
        }
      }

    case GET_SHORT_LINK_SUCCESS:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.additional.id]: false,
        },
        isLoaded: {
          ...state.isLoaded,
          [action.additional.id]: true,
        },
        shortLinks: {
          ...state.shortLinks,
          [action.additional.id]: action.response.shortLink[action.additional.url]
        }
      }

    case GET_SHORT_LINK_FAIL:
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.additional.id]: false,
        },
        isLoaded: {
          ...state.isLoaded,
          [action.additional.id]: false,
        }
      }

    case GET_SHORT_LINKS: {
      const isLoading = action.additional.urls.reduce((prev, next) => ({
        ...prev,
        [next]: true
      }), {});
      const isLoaded = action.additional.urls.reduce((prev, next) => ({
        ...prev,
        [next]: false
      }), {});
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          ...isLoading
        },
        isLoaded: {
          ...state.isLoaded,
          ...isLoaded
        },
      }
    }

    case GET_SHORT_LINKS_SUCCESS: {
      const isLoading = action.additional.urls.reduce((prev, next) => ({
        ...prev,
        [next]: false
      }), {});
      const isLoaded = action.additional.urls.reduce((prev, next) => ({
        ...prev,
        [next]: true
      }), {});
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          ...isLoading
        },
        isLoaded: {
          ...state.isLoaded,
          ...isLoaded
        },
        shortLinks: {
          ...state.shortLinks,
          ...action.response.shortLink
        },
        isLoadedArr: [
          ...state.isLoadedArr,
          ...action.additional.urls
        ]
      }
    }

    case GET_SHORT_LINKS_FAIL: {
      const isLoading = action.additional.urls.reduce((prev, next) => ({
        ...prev,
        [next]: false
      }), {});
      const isLoaded = action.additional.urls.reduce((prev, next) => ({
        ...prev,
        [next]: false
      }), {});

      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          ...isLoading
        },
        isLoaded: {
          ...state.isLoaded,
          ...isLoaded
        }
      }
    }

    default:
      return state;
  }
}
